function _________(response) {
  return ('SOMOS UN EXITO!!');
}
module.exports.listasEstados = function listasEstados(action, response) {
  return new Promise((resolve, reject) => {
    switch (action) {
      case '_______':
        resolve(_______(response));
        break;
      default:
        reject('Error');
        break;
    }
  });
};




// WEBPACK FOOTER //
// ./src/js/modulosChatBox/listas.js